<ion-app>
  <ion-split-pane contentId="main-content">
    <ion-menu contentId="main-content" type="overlay">
      <ion-content>
        <ion-list id="inbox-list">
          <ion-list-header>{{'menus.main.title-menu' | translate}}</ion-list-header>
          <!-- <ion-item *ngIf="user" class="user-menu-toggle" routerDirection="root" (click)="showUserPopover($event)" lines="none" detail="false">
          <ion-icon slot="end" ios="chevron-down-outline" md="chevron-down-sharp"></ion-icon>
          <ion-label>{{user.email}}</ion-label>
        </ion-item> -->

        <ion-menu-toggle auto-hide="false">
          <ion-item routerDirection="root" routerLink="/settings" lines="none" detail="false">
            <ion-icon slot="start" ios="settings-outline" md="settings-sharp"></ion-icon>
            <ion-label>{{'menus.main.btn-settings' | translate}}</ion-label>
          </ion-item>
        </ion-menu-toggle>

        <ion-menu-toggle auto-hide="false">
          <ion-item routerDirection="root" routerLink="/photo-upload" lines="none" detail="false">
            <ion-icon slot="start" ios="cloud-upload-outline" md="cloud-upload-sharp"></ion-icon>
            <ion-label>{{'pages.start.btn-upload' | translate}}</ion-label>
          </ion-item>
        </ion-menu-toggle>

        <ion-menu-toggle auto-hide="false">
          <ion-item routerDirection="root" routerLink="/jobs" lines="none" detail="false">
            <ion-icon slot="start" ios="cog-outline" md="cog-sharp"></ion-icon>
            <ion-label>{{'pages.start.btn-observations' | translate}}</ion-label>
          </ion-item>
        </ion-menu-toggle>

      </ion-list>

      <ion-list id="labels-list">
        <ion-list-header>{{'menus.main.title-info' | translate}}</ion-list-header>

        <ion-menu-toggle auto-hide="false">
          <ion-item routerDirection="root" lines="none" routerLink="/info/tabs/info-faq" detail="false">
            <ion-label>{{'pages.info.btn-faq' | translate}}</ion-label>
          </ion-item>
        </ion-menu-toggle>

        <ion-menu-toggle auto-hide="false">
          <ion-item routerDirection="root" lines="none" routerLink="/info/tabs/info-usage" detail="false">
            <ion-label>{{'pages.info.btn-terms' | translate}}</ion-label>
          </ion-item>
        </ion-menu-toggle>

        <ion-menu-toggle auto-hide="false">
          <ion-item routerDirection="root" lines="none" routerLink="/info/tabs/info-privacy" detail="false">
            <ion-label>{{'pages.info.btn-privacy' | translate}}</ion-label>
          </ion-item>
        </ion-menu-toggle>

        <ion-menu-toggle auto-hide="false">
          <ion-item routerDirection="root" lines="none" routerLink="/info/tabs/info-imprint" detail="false">
            <ion-label>{{'pages.info.btn-imprint' | translate}}</ion-label>
          </ion-item>
        </ion-menu-toggle>

      </ion-list>
    </ion-content>
  </ion-menu>
  <ion-router-outlet id="main-content"></ion-router-outlet>
</ion-split-pane>
</ion-app>
